
















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import { VueComponent } from "../shared/types/VueComponent";
import HelpMessage from './HelpMessage/HelpMessage.vue'
import HighlightAnchor from './HighlightAnchor.vue'
import Tags from './Tags/Tags.vue'
import { TagData } from './Tags/types'

@Component({
  components: {
    Tags,
    HelpMessage,
    HighlightAnchor
  },
})
export default class PageTitle extends Vue {
  @Prop({ 'type': Array }) readonly tags!: Array<TagData>

  @Prop({ type: [ Object, Array ] }) readonly translationParams!: Array<any> | Record<string, any>

  @Prop({ type: Boolean, default: true, required: false }) hasAnchorIcon!: boolean

  @Prop() customHelpMessage!: VueComponent | string

  @Prop() subtitle!: string | undefined

  @Prop() title!: string | undefined

  @Prop() helpMessage!: string | undefined

  get titleData(): string | null {
    if (this.title !== undefined) {
      return this.title
    }

    if (this.$route.name) {
      return this.$t(`${ this.$route.name.toLowerCase() }_page_title`, this.translationParams).toString()
    }

    return null
  }

  get pageHelpMessage(): string | null {
    if (this.helpMessage !== undefined) {
      return this.helpMessage
    }

    if (this.$route.name) {
      const pageHelpMessageKey = `${ this.$route.name.toLowerCase() }_page_help_message`

      return this.$te(pageHelpMessageKey)
        ? this.$t(pageHelpMessageKey, this.translationParams).toString()
        : null
    }

    return null
  }

  get subtitleData(): string | null {
    if (this.subtitle !== undefined) {
      return this.subtitle
    }

    if (this.$route.name) {
      const pageDescriptionKey = `${ this.$route.name.toLowerCase() }_page_description`

      return this.$te(pageDescriptionKey)
        ? this.$t(pageDescriptionKey, this.translationParams).toString()
        : null
    }

    return null
  }
}
